export const contactSupportPageTranslations = {
  title: 'Assistance',
  sections: {
    phone: {
      title: 'Téléphone',
      number: 'Numéro',
      phone_number: '09 70 80 85 95',
      opening_time: 'Horaires d’ouverture',
      opening_time_value:
        'Nos services sont ouverts de 8h30 à 18h00 du lundi au vendredi (sans surtaxe)',
    },
    appointment: {
      title: 'Rendez-vous',
      axa_epargne_entreprise: 'AXA Epargne Entreprise',
      standard_contract_link:
        'Prendre un rendez-vous pour des demandes sur un contrat épargne salarial et épargne retraite standard déjà mis en gestion',
      new_business: 'Nouvelles Affaires',
      new_business_link:
        'Prendre un rendez-vous pour la mise en place des affaires nouvelles épargne salarial et épargne retraite standard',
    },
    email: {
      title: 'Email',
      label: 'Formulaire de contact',
      button: 'Écrivez-nous',
      es_label: "À propos du contrat d'épargne salariale",
      er_label: 'À propos du contrat de retraite salariale',
      inspector_label: "Courriel de l'inspecteur collectif",
    },
    tour: {
      start_tour: 'Démarrer la visite',
    },
  },
  contact_request: {
    title: 'Formulaire de contact',
    label: 'Écrivez-nous',
    steps: {
      request: 'Demande',
      confirmation: 'Confirmation',
    },
    sections: {
      request: 'Demande',
      request_details: 'Détails de la demande',
    },
    fields: {
      subject: 'Objet',
      contract_id: 'Numéro de contrat',
    },
    confirmation: {
      title: 'Email envoyé avec succès',
      message: 'Votre demande a été envoyée par email avec succès.',
      confirmation: 'Compris',
    },
    choices: {
      subject: {
        navigation_help: 'Aide à la navigation espace client',
        contribution_call: 'Appel de cotisation',
        arbitration: 'Arbitrage',
        amendment: 'Avenant',
        bia: 'BIA',
        monetized_leave: 'Congé Monétisé',
        death: 'Décès',
        nominative_declaration: 'Déclaration nominative',
        evaluation_request: 'Demande d’évaluation',
        dsn: 'DSN',
        taxation: 'Fiscalité',
        merger: 'Fusion',
        end_of_career_bonus: 'Indemnité de fin de carrière',
        liquidation: 'Liquidation',
        administrative_change: 'Modification administrative',
        annuity_payment: 'Paiement de la rente',
        profit_sharing: 'Participation/Intéressement/PPV',
        matching_contribution: 'Abondement',
        regularization: 'Régularisation',
        redemption: 'Rachat',
        contract_termination: 'Résiliation de contrat',
        account_statement: 'Situation de compte',
        pricing_commercial: 'Tarifaire/commercial',
        transfer: 'Transfert',
        payment: 'Versement',
        other: 'Autre (préciser)',
        complaint: 'Réclamation',
      },
    },
  },
  accessibility: {
    back: 'Retour',
  },
};
